/* eslint-disable no-console */
export const logger = (store) => (next) => (action) => {
  const prevState = store.getState();
  const returnResult = next(action);
  const nextState = store.getState();

  if (process.env.NODE_ENV === "development") {
    console.groupCollapsed(
      `%caction %c${action.type} %c@ ${new Date().toLocaleTimeString("en-US", {
        hour12: false
      })}`,
      "color: #a0a0a0",
      "font-weight: bold",
      "color: #a0a0a0"
    );
    console.log("%cprev state", "color: #a0a0a0; font-weight: bold", prevState);
    console.log("%caction    ", "color: #33aaf4; font-weight: bold", action);
    console.log("%cnext state", "color: #4eb053; font-weight: bold", nextState);
    console.groupEnd();
  }

  return returnResult;
};
